export { default, default as EditPracticeModal } from "./EditPracticeModal";
